/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from 'react'

import { inject } from '@vercel/analytics'
import { useRouter } from 'next/router'
import Script from 'next/script'

import { isProduction } from 'lib/utils/environments'

import { rudder } from './rudder'
import { userAccepptedCookies } from './tracking-cookie'

import { FCC } from 'types/react'

export const AnalyticsContext: FCC = ({ children }) => {
  const { events, isReady } = useRouter()
  const [enableTracking, setEnableTracking] = useState(false)

  // Turn on tracking in a useEffect to avoid React hydration mismatches.
  // TODO: Revisit this solution when React's postpone api is released
  // https://github.com/facebook/react/pull/27238
  useEffect(() => {
    if (userAccepptedCookies) setEnableTracking(true)
  }, [])

  // Track page changes
  useEffect(() => {
    if (!enableTracking) {
      return
    }

    const track = () => {
      // https://github.com/vercel/next.js/issues/11639
      if (isReady) {
        rudder?.page()
      }
    }

    events.on('routeChangeComplete', track)

    return () => {
      events.off('routeChangeComplete', track)
    }
  }, [enableTracking, events, isReady])

  // Enable Vercel analytics on production, Vercel does not use personal information,
  // so we don't need to disable when cookies are not accepted.
  useEffect(() => {
    if (location?.hostname === 'grafbase.com') {
      inject()
    }
  }, [])

  return (
    <>
      {isProduction && (
        <Script
          id="koala"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html:
              '!function(t){if(window.ko)return;window.ko=[],["identify","track","removeListeners","open","on","off","qualify","ready"].forEach(function(t){ko[t]=function(){var n=[].slice.call(arguments);return n.unshift(t),ko.push(n),ko}});var n=document.createElement("script");n.async=!0,n.setAttribute("src","https://cdn.getkoala.com/v1/pk_a99db261bb24515d8c2db567e85d0aa9a3f7/sdk.js"),(document.body || document.head).appendChild(n)}();',
          }}
        />
      )}
      {enableTracking && isProduction && (
        <Script id="google-tag-manager" strategy="afterInteractive">
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_GOOGLE_TAG_TRACKING_ID}');
          `}
          {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'AW-11163587136');
            `}
        </Script>
      )}
      {enableTracking && isProduction && (
        <>
          <Script id="linkedin-insight-tag" strategy="afterInteractive">
            {`_linkedin_partner_id="5845881";window._linkedin_data_partner_ids=window._linkedin_data_partner_ids||[];window._linkedin_data_partner_ids.push(_linkedin_partner_id);(function(l){if(!l){window.lintrk=function(a,b){window.lintrk.q.push([a,b])};window.lintrk.q=[]}var s=document.getElementsByTagName("script")[0];var b=document.createElement("script");b.type="text/javascript";b.async=true;b.src="https://snap.licdn.com/li.lms-analytics/insight.min.js";s.parentNode.insertBefore(b,s)})(window.lintrk);`}
          </Script>
          <noscript>
            <img
              height="1"
              width="1"
              style={{ display: 'none' }}
              alt=""
              src="https://px.ads.linkedin.com/collect/?pid=5845881&fmt=gif"
            />
          </noscript>
        </>
      )}
      {children}
    </>
  )
}
